<template>
  <v-container class="pa-0">
    <v-row justify="center">
      <span v-for="total in totals" :key="total.name">
        <strong>{{ total.label }}</strong
        >: {{ total.value }}&nbsp;
      </span>
    </v-row>
    <v-row v-if="debug">
      <v-col>
        <code>{{ value }}</code></v-col
      >
    </v-row>
  </v-container>
</template>

<script>
import { getTotal, groupByFn } from "../../../helpers";
export default {
  name: "list-totals",

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      debug: false,
    };
  },
  computed: {
    totals() {
      return this.value.map((c) => {
        let total = getTotal(this.items, (item) =>
          Number(item[c.value])
        ).toFixed(2);
        if (c.groupBy && c.groupBy != "") {
          const grouped = groupByFn(this.items, (item) => item[c.groupBy]);
          const groupedTotals = Object.keys(grouped).map((key) => ({
            label: `${key}`,
            value: getTotal(grouped[key], (item) =>
              Number(item[c.value])
            ).toFixed(2),
          }));
          total = groupedTotals.map((g) => `${g.label} ${g.value}`).join(" | ");
        }
        return {
          label: `Total ${c.text}`,
          value: total,
        };
      });
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/gt/shared/ListTotals.vue